<template>
  <!-- 教学行为分析 -->
  <div class="teaching-behavior-analysis-container">
    <div class="title">
      <span></span>
      <span>近七天教学行为分析</span>
    </div>
    <div class="container">
      <div style="width:100%;height: 100%" id="teaching-behavior-echarts-id"
           :style="{zoom:`${zoom}`,transformOrigin:'0 0'}"/>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  comments: {},
  computed: {},
  name: "teaching-behavior-analysis",
  props: {
    teachingBehaviorData: {
      type: Object,
      default: () => {
        return {
          tabulaRasaNum: 0,
          textbookNum: 0,
          classroomActivityNum: 0,
          classroomEvaluationNum: 0,
          sparkResourceNum: 0
        }
      }
    },
    zoom: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      //屏幕宽度
      screenWidth: 0,
      // 屏幕高度
      screenHeight: 0,
      // 没有数据
      noData: false,
      // 新增属性，用于存储当前的 ECharts 实例
      echartsInstance: null,
    }
  },
  watch: {
    screenHeight: "initEcharts",
    teachingBehaviorData(value) {
      if (value) {
        this.$nextTick(() => {
          this.initEcharts()
        })
      }
    }
  },
  mounted() {
    //获取屏幕宽度
    this.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    //获取屏幕高度
    this.screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  },
  methods: {
    initEcharts() {
      // 销毁旧的 ECharts 实例
      if (this.echartsInstance) {
        this.echartsInstance.dispose();
      }
      let maxValue = Math.max(...Object.values(this.teachingBehaviorData))

      const dataSources = {
        data: [this.teachingBehaviorData.tabulaRasaNum,
          this.teachingBehaviorData.textbookNum,
          this.teachingBehaviorData.classroomActivityNum,
          this.teachingBehaviorData.classroomEvaluationNum,
          this.teachingBehaviorData.sparkResourceNum],
        indicator: [
          {name: '电子白板', max: maxValue},
          {name: '电子教材', max: maxValue},
          {name: '课堂活动', max: maxValue},
          {name: '作业讲评', max: maxValue},
          {name: '火花资源', max: maxValue},
        ]
      }
      // 构建series
      const buildSeries = (data) => {
        const helper = data.map((item, index) => {
          const arr = new Array(data.length)
          arr.splice(index, 1, item)
          return arr
        })

        return [data, ...helper].map((item, index) => {
          return {
            type: 'radar',
            // 单个数据标记的图形。
            symbol: 'circle',
            // 单个数据标记的大小，可以设置成诸如 10 这样单一的数字，也可以用数组分开表示宽和高，例如 [20, 10] 表示标记宽为20，高为10。
            symbolSize: 10,
            // 单个拐点标志的样式设置。
            itemStyle: {
              normal: {
                // 拐点颜色
                color: '#06D6F8',
                // 拐点的描边颜色。[ default: '#000' ]
                borderColor: '#FFFFFF',
                // 拐点的描边宽度，默认不描边。[ default: 0 ]
                borderWidth: 3,
              },
            },
            // 单项线条样式。
            lineStyle: {
              normal: {
                color: '#2898BC',
                opacity: 0.2
              }
            },
            areaStyle: {
              normal: { // 单项区域填充样式
                color: {
                  type: 'linear',
                  x: 0, //右
                  y: 0, //下
                  x2: 1, //左
                  y2: 1, //上
                  colorStops: [{
                    offset: 0,
                    color: '#4BFFFC'
                  }, {
                    offset: 0.5,
                    color: 'rgba(0,0,0,0)'
                  }, {
                    offset: 1,
                    color: '#4BFFFC'
                  }],
                  globalCoord: false
                },
                opacity: 1 // 区域透明度
              }
            },
            tooltip: {
              show: index !== 0,
              formatter: function () {
                return dataSources.indicator[index - 1].name + ': ' + dataSources.data[index - 1];
              }
            },
            z: index === 0 ? 1 : 2,
            data: [item]
          }
        })
      }

      let option;

      option = {
        tooltip: {},

        radar: {
          // shape: 'circle',
          // radius: 120,//缩放
          center: ['50%', '55%'], // 水平方向和垂直方向都居中
          name: {
            textStyle: {
              color: '#fff',
              fontSize: 14,
              // padding: [-10, -12],
            },
          },
          indicator: dataSources.indicator,
          splitArea: { // 坐标轴在 grid 区域中的分隔区域，默认不显示。
            show: false,
            // areaStyle: { // 分隔区域的样式设置。
            //   color: ['rgba(255,255,255,0)', 'rgba(255,255,255,0)'], // 分隔区域颜色。分隔区域会按数组中颜色的顺序依次循环设置颜色。默认是一个深浅的间隔色。
            // }
          },
          axisLine: { //指向外圈文本的分隔线样式
            show: true,
            lineStyle: {
              color: '#153269'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#3C5BA5', // 分隔线颜色
              width: 2, // 分隔线线宽
            },
          },
          splitNumber: 1
        },
        series: buildSeries(dataSources.data)
      };

      this.echartsInstance = this.$echarts.init(
          document.getElementById("teaching-behavior-echarts-id")
      );
      this.echartsInstance.setOption(option);

      window.addEventListener("resize", () => {
        this.echartsInstance.resize();
      });
    }
  },
}

</script>

<style scoped lang="scss">
.teaching-behavior-analysis-container {
  background-image: url("../../../assets/images/nanjingdataboard/bg-2.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;

  .title {
    position: relative;
    width: 100%;
    top: 35px;
    height: 30px;
    font-family: Microsoft YaHei, serif;
    font-weight: bold;
    font-size: 20px;
    color: #FFFFFF;
    text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
    text-align: left;
    //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
    //-webkit-background-clip: text;
    //-webkit-text-fill-color: transparent;

    span:nth-of-type(1) {
      display: inline-block;
      transform: translateY(2px);
      width: 8px;
      height: 18px;
      background: #06D6F8;
      border-radius: 4px;
      margin-left: 20px;
    }

    span:nth-of-type(2) {
      width: 120px;
      height: 20px;
      font-family: Microsoft YaHei;
      margin-left: 10px;
      font-weight: bold;
      font-size: 20px;
      color: #FFFFFF;
      text-shadow: 0 3px 7px rgba(0, 0, 0, 0.35);
      //background: linear-gradient(0deg, rgba(77, 190, 255, 0.62) 0%, rgba(77, 190, 255, 0) 100%);
      //-webkit-background-clip: text;
      //-webkit-text-fill-color: transparent;
    }
  }

  .container {
    position: relative;
    top: 35px;
    width: 100%;
    height: calc(100% - 65px);
  }
}

</style>